import {assetProjectEnabled} from './assetProjectEnabled';
import {
    currentUserHasAccess,
    PermissionName,
} from '@netx/core-permissions-next';

export const userCanCreateAssetProjects = () => {
    return assetProjectEnabled() && currentUserHasAccess(PermissionName.CREATE_REVIEWS);
};
